import React from 'react'
import {compose} from 'recompose'
import {GoverningOrganizationList} from 'views/Workspace/Host/WorkspaceGoverningOrganizations'
import {SubordinateUnitList} from 'views/Workspace/Host/WorkspaceSubordinateUnits'
import {HostProvider} from '../Host/HostContext'
import {DefaultSettingHeader} from './createSettingContent'

const withHostSetting = (Component) => {
  return function Wrapper({ item, ...props }) {
    return (
      <HostProvider container={item}>
        <Component
          {...{
            Header: ({ title, extra }) => (
              <DefaultSettingHeader
                title={title}
                extra={extra}
              />
            ),
          }}
          {...props}
        />
      </HostProvider>
    )
  }
}

export const CoHosts = compose(withHostSetting)(GoverningOrganizationList)

export const CoOwners = compose(withHostSetting)(SubordinateUnitList)
